import FetchFactory from '../factory';
import type { FetchOptions } from 'ofetch';

export type PaymentOption = {
  model: {
    payment_methods: PaymentMethod[];
  };
};

export type PaymentMethod = {
  payment_method_system_name: string;
  payment_method_frontend_name?: string;
  name: string;
  description: string;
  fee: string;
  selected: boolean;
  logo_url: string;
  custom_properties: {
    additionalProp1: string;
    additionalProp2: string;
    additionalProp3: string;
  };
};

export type SelectPaymentMethodResponse =
  | {
      redirect_to_method?: string;
      id?: number;
    }
  | string;

class PaymentModule extends FetchFactory<any> {
  async getPaymentOptions() {
    const url = '/api-frontend/Checkout/PaymentMethod';
    const fetchOptions: FetchOptions<'json'> = {
      headers: {
        'Accept-Language': 'en-US',
      },
    };

    return await this.call(
      'GET',
      url,
      undefined, // body
      fetchOptions,
    );
  }

  /**
   * Set the payment method in backend
   * @param paymentMethodSystemName (string) paymentMethod.payment_method_system_name e.g. Payments.Electra.Swish
   * @param swishNumber (string) phone number for swish, only required if swish is the payment method
   * @param useRewardPoint (boolean) discount ???
   * @returns
   */
  async selectPaymentMethod(
    paymentMethodSystemName: string,
    swishNumber: string = '',
    useRewardPoint: boolean = false,
  ): Promise<SelectPaymentMethodResponse> {
    const url = 'api-electra/Checkout/SelectPaymentMethod';

    return await this.call('POST', url, {
      PaymentMethod: paymentMethodSystemName,
      SwishNumber: swishNumber,
      UseRewardPoint: useRewardPoint,
    });
  }

  async getPaymentInfo(): Promise<any> {
    const url = `api-frontend/Checkout/PaymentInfo`;
    return await this.call('GET', url);
  }

  async getPaymentInfoWebView(orderId: number): Promise<string> {
    const url = `/shop/api-fe-server/paymentinfowebview/${orderId}`;
    return await this.call('GET', url, undefined, {
      baseURL: '',
    });
  }
}

export default PaymentModule;
